import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getItemCompany = createAsyncThunk('/itemCompany/getItemCompany',
    async (payload) => {
        try {
            const payloadData = {
                status: payload.status
            }

            const myurl = `${V_URL}/prosafe/get-item-company`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: payloadData,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            
            toast.error(error.response.data.message);
            return error
        }
    })

const getItemCompanySlice = createSlice({
    name: "getItemCompany",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getItemCompany.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getItemCompany.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getItemCompany.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getItemCompanySlice.reducer;